//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";

export default {
    name: "ViewAQDefaultState",
    components: {
        AQEmptyState,
        AQDropdown
    },
    data() {
        return {
            showCustomContent: false,
            option: false,
            defaultStateData: {
                title: "",
                description: ""
            },
            customStateData: {
                title: "Custom Title",
                description: "Custom Description"
            },
            rulesOpts: [
                { label: "Application", value: "application" },
                { label: "entity", value: "entity" },
                { label: "integration", value: "integration" },
                { label: "notasks", value: "notasks" },
                { label: "noteamtask", value: "noteamtask" },
                { label: "createProcess", value: "createProcess" },
                { label: "createSC", value: "createSC" },
                { label: "createInterface", value: "createInterface" },
                { label: "createDocument", value: "createDocument" },
                { label: "internalApis", value: "internalApis" },
                { label: "consumedApis", value: "consumedApis" },
                { label: "exposedApis", value: "exposedApis" },
                { label: "createDM", value: "createDM" },
                { label: "createCatalog", value: "createCatalog" },
                { label: "createPerspective", value: "createPerspective" },
                { label: "noPerspective", value: "noPerspective" },
                { label: "noPerspectiveProcess", value: "noPerspectiveProcess" },
                { label: "noStatistics", value: "noStatistics" },
                { label: "noProcessData", value: "noProcessData" },
                { label: "acessDenied", value: "acessDenied" },
                { label: "blockchainWallet", value: "blockchainWallet" },
                { label: "maintenance", value: "maintenance" }
            ],
            emptyStateType: "application"
        };
    },
    methods: {
        changeEmptyState(evt) {
            this.emptyStateType = evt[0].value;
        },
        createNew() {
            alert("You just created something new");
        },
        secondaryAction() {
            alert("Congratulations, you just used the secondary button!");
        }
    }
};
